import React, { useState, useEffect } from 'react';
import api from './api';
import LoginPage from './LoginPage';
import ChatPage from './ChatPage';

export default function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('terka_token');
    if (!token) { setLoading(false); return; }

    api.get('/auth/me')
      .then(({ data }) => {
        if (data.success) setUser(data.user);
        else throw new Error();
      })
      .catch(() => {
        localStorage.removeItem('terka_token');
        localStorage.removeItem('terka_refresh');
      })
      .finally(() => setLoading(false));
  }, []);

  const handleLogout = () => {
    localStorage.removeItem('terka_token');
    localStorage.removeItem('terka_refresh');
    setUser(null);
  };

  if (loading) {
    return (
      <div style={{
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        height: '100vh', fontSize: 18, color: '#0088CC',
      }}>
        Загрузка...
      </div>
    );
  }

  if (!user) return <LoginPage onLogin={setUser} />;
  return <ChatPage user={user} onLogout={handleLogout} />;
}
